angular.module("avlib").filter('avOrderBy', ["orderByFilter", function(orderByFilter) {
	
	return function(input, expression, reverse, comparator, tableModel, sortModel) {
		if (tableModel.getColumnType){
			var columnType = tableModel.getColumnType(sortModel.sortColumn);
			if (columnType == "localeSensitiveString"){
				comparator = function(v1, v2){
					if (v1.type == "string" && v2.type == "string"){
						return v1.value.localeCompare(v2.value);
					}
				};
			}
		}
		return orderByFilter(input, expression, reverse, comparator);
	}
}]);
